<template>
  <div class="page-footer">
    <a href="#" class="top icon-arrow" @click.prevent="toTop" ondragstart="return false;">
      <span class="icon-arrow"></span>
    </a>
    <div class="flexer">
      <p class="copy">&copy; 2021 enercity AG</p>
      <social-share/>
      <nav>
        <ul>
          <li><a href="https://www.enercity.de/kontakt" target="_blank" draggable="false" ondragstart="return false;">Kontakt</a></li>
          <li><a href="https://www.enercity.de/datenschutz" target="_blank" draggable="false" ondragstart="return false;">Datenschutz</a></li>
          <li><a href="https://www.enercity.de/impressum" target="_blank" draggable="false" ondragstart="return false;">Impressum</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import SocialShare from "@/elements/SocialShare";
export default {
  name: "PageFooter",
  components: {SocialShare},
  emits: ['scroll-to-top'],
  methods: {
    toTop() {
      this.$emit('scroll-to-top');
    }
  }
}
</script>

<style scoped>
  .page-footer {
    padding: 45px 60px;
    color: #A7A9AC;
    font-weight: 500;
    font-size: 15px;
  }
  .flexer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    clear: right;
  }
  p {
    margin: 0;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0 -20px;
  }
  li {
    display: inline-block;
    padding: 0 10px;
  }
  nav a {
    padding: 10px;
    color: #A7A9AC;
    text-decoration: none;
    transition: 0.3s ease;
  }
  nav a:hover {
    color: #102D61;
  }
  .top {
    position: relative;
    display: block;
    width: 60px;
    height: 60px;
    background-color: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    float: right;
    margin: 20px -4px;
    font-family: "Icons", sans-serif;
    color: #C7125C;
    font-size: 18px;
    text-decoration: none;
    overflow: hidden;
    transition: 0.3s ease;
  }
  .top span, .top:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease;
  }
  .top span {
    transform: translate3d(0, 70%, 0);
    color: white;
  }
  .top:hover {
    background-color: #3ABABA;
  }
  .top:hover:before {
    transform: translate3d(0, -70%, 0);
  }
  .top:hover span {
    transform: translate3d(0, 0, 0);
  }
  @media(max-width: 1199px), (max-height: 799px) {
    .page-footer {
      padding: 30px;
    }
  }
  @media(max-width: 999px) {
    .page-footer {
      position: relative;
      display: block;
      padding: 50px 34px;
      box-shadow: 0 100px 100px 100px rgba(0, 0, 0, 0.1);
      z-index: 2;
    }
    .top {
      position: absolute;
      top: -30px;
      margin: 0;
      right: 15px;
    }
    .flexer {
      display: block;
    }
    .copy {
      margin-bottom: 15px;
    }
    nav {
      margin-top: 12px;
      padding: 0 10px;
    }
    nav li {
      padding: 3px 0;
    }
  }
  @media(max-width: 767px) {
    .page-footer {
      padding: 40px 20px;
    }
  }
</style>